import { IAppTheme } from '@msx/platform-services'

export const getStyles = (theme: IAppTheme) => {
  return {
    headingMain: {
      fontWeight: 600,
      fontSize: '28px',
      lineHeight: '36px',
      textAlign: 'center',
    },
    homePageButton: {
      padding: '5px',
      borderRadius: '5px',
    },
    test: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      textAlign: 'center',
    },
    description: {
      fontWeight: 400,
      fontSize: '16px',
      lineHeight: '22px',
      textAlign: 'center',
      width: '546px',
      marginBottom: '20px'
    },
    errorImage: {
      marginBottom: '20px'
    }
  };
};
